<template>
  <div class="w-full flex flex-col gap-2">
    <form @submit.prevent="updateGroup" class="w-full">
      <!-- <div class="w-full">
        <div class="mt-4">
          <b-field :label="$t('groups') + ' padre'">
            <treeselect v-model="groupParent"
              :multiple="false"
              :options="groups"
              :disabled="!form.id && !!form.parent_id"
            />
          </b-field>
        </div>
      </div> -->

      <div class="w-full pb-3">
        <div class="w-full">
          <label form="name" class="">{{ $t('name')}}</label>
          <v-input
            v-model="form.name"
            title="name"
            type="text"
            required="true"
            name="name"
            placeholder="name"
          />
        </div>
      </div>

      <div class="w-full mb-3">
        <label form="weight">{{ $t('weight') }}</label>
        <b-numberinput v-model="form.weight" controls-position="compact"
          min="0" max="100"
          expanded icon-pack="fas"></b-numberinput>
      </div>

      <!-- <div class="w-full pb-3">
        <label form="color">{{ $t('select_a_color') }}</label>
        <b-colorpicker v-model="form.color"
          :alpha="false"
          :inline="colorpickerInline"
          :color-formatter="formatter"
          size="is-medium"
          expanded
        />
      </div> -->

      <div v-if="showActions" class="w-full flex flex-row justify-between gap-x-2 pb-3 mt-8">
        <button type="button"
          class="btn btn-default"
          @click="() => { $emit('epc-group-status-form-close') }">
          Cancelar
        </button>

        <button
          class="btn btn-blue"
          nativeType="submit"
        >
          {{ $t( form.id != null ? 'edit' : 'add' ) }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Form from 'vform';

export default {
  name: 'LayerGroupStatus',
  props: {
    group: {
      type: Object,
      default: null
    },
    showActions: {
      type: Boolean,
      default: true
    },
    layerId: {
      type: Number,
      default: null
    },
    colorpickerInline: { type: Boolean, default: false } // Indica si el selector de color se mostrara en linea o haciendo click en un input
  },
  data() {
    return {
      form: new Form({
        id: this.group.id ?? null,
        parent_id: this.group.parent_id ?? null,
        code: this.group.code ?? null,
        name: this.group.name ?? null,
        weight: this.group.weight ?? null,
        color: this.group.color ?? null,
        type: this.group.type ?? 'group',
      }),

      formatColor: 'hex',
    };
  },

  watch: {
    group: {
      handler(newVal) {
        if (newVal) {
          this.form.id = newVal.id ?? null;
          this.form.parent_id = newVal.parent_id ?? null;
          this.form.code = newVal.code ?? null;
          this.form.name = newVal.name ?? null;
          this.form.weight = newVal.weight !== undefined && newVal.weight !== null ? newVal.weight : null;
          this.form.color = newVal.color ?? null;
          this.form.type = newVal.type ?? 'group';
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    formatter (color) {
      return color.toString(this.formatColor)
    },

    buildPayload() {
      // Normalizar color: si está vacío o es negro default, mandar null
      const color = this.form.color == null || this.formatter(this.form.color) === '#000000'
        ? null
        : this.formatter(this.form.color);

      return {
        id:        this.form.id,         // null en create, id positivo en edit
        parent_id: this.form.parent_id,
        code:      this.form.code,
        name:      this.form.name,
        weight:    this.form.weight,
        color,
        type:      this.form.type,
      };
    },

    async updateGroup() {
      // this.$toast.open({
      //   message: msg,
      //   type: 'is-danger',
      //   position: 'is-top-right'
      // })
      const g = this.getData();
      this.$emit('epc-add-group', g)
      this.reset()
    },

    reset() {

      this.form.id = null
      this.form.parent_id = null
      this.form.code = null
      this.form.name = null
      this.form.weight = null
      this.form.color = null
      this.form.type = 'group'

      this.processingData = false
    },

    getData() {
      return {
        id: this.form.id,
        parent_id: this.form.parent_id,
        code: this.form.code,
        name: this.form.name,
        weight: this.form.weight,
        color: this.form.color,
        type: this.form.type,
      };
    }
  }
};
</script>
